import React from 'react';

export function BusinessCenterIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M40 14h-8v-4l-4-4h-8l-4 4v4H8c-2.2 0-4 1.8-4 4v10c0 1.5.8 2.76 2 3.46V38c0 2.22 1.78 4 4 4h28c2.22 0 4-1.78 4-4v-6.56c1.18-.7 2-1.98 2-3.44V18c0-2.2-1.8-4-4-4zm-20-4h8v4h-8v-4zM8 18h32v10H30v-6H18v6H8V18zm18 12h-4v-4h4v4zm12 8H10v-6h8v2h12v-2h8v6z" />
    </svg>
  );
}
